/**
 * GraphQL Query
 * メール関連
 */

/**
 * メールテンプレ
 */
export const GRAPH_QL_QUERY_MAIL_TEMPLATE =
`
query {
  mailTemplate {
    id
    uuid
    siteId
    type
    templateName
    from
    fromMine
    to
    cc
    bcc
    replyTo
    subject
    templateText
    templateHtml
    updatedAt
  }
}
`

/**
 * メールテンプレ(簡易)
 */
export const GRAPH_QL_QUERY_MAIL_TEMPLATE_SIMPLE =
`
query {
  mailTemplates (?) {
    edges {
      node {
        uuid
        templateName
      }
    }
    totalCount
  }
}
`
